import { useDataTypesHooks } from "../../../features/data-types"
import { useSaleOperationLoaders } from "../../sales"
import { useCreditPaymentLoaders } from "../loaders/creditPaymentLoaders"
import { usePaymentOrderLoaders } from "../loaders/paymentOrderLoaders"
import { useTransactionLoaders } from "../loaders/transactionLoaders"
import { Check } from "../state/types"

export const useCheckHooks = () => {
    const { formatPrice } = useDataTypesHooks()
    
    const creditPaymentLoaders = useCreditPaymentLoaders()
    const saleOperationLoaders = useSaleOperationLoaders()
    const paymentOrderLoaders = usePaymentOrderLoaders()
    const transactionLoaders = useTransactionLoaders()

    const describeCheck = (check: Check): string => {
        return `${check.name} (${formatPrice(check.amount)})`
    }

    const canRemoveCheck = async (checkId: string): Promise<boolean> => {
        const { countCreditPayments } = creditPaymentLoaders()
        const creditPaymentsCount = await countCreditPayments('destinationId', checkId)
        
        const { loadSaleOperationsWithProp } = saleOperationLoaders()
        const saleOperationsWithPaymentItems = await loadSaleOperationsWithProp('paymentItems', true)
        const saleOperations = saleOperationsWithPaymentItems.filter(saleOperation => saleOperation.paymentItems.some(paymentItem => paymentItem.destinationId === checkId))

        const { loadPaymentOrdersWithProp } = paymentOrderLoaders()
        const paymentOrdersWithPaymentItems = await loadPaymentOrdersWithProp('paymentItems', true)
        const paymentOrders = paymentOrdersWithPaymentItems.filter(paymentOrder => paymentOrder.paymentItems.some(paymentItem => paymentItem.sourceId === checkId))
        
        const { countTransactions } = transactionLoaders()
        const sourceTransactionsCount = await countTransactions('sourceId', checkId)
        const destinationTransactionsCount = await countTransactions('destinationId', checkId)
        const transactionsCount = sourceTransactionsCount + destinationTransactionsCount

        return  creditPaymentsCount === 0 &&
            saleOperations.length === 0 &&
            paymentOrders.length === 0 &&
            transactionsCount === 0
    }

    return {
        describeCheck,
        canRemoveCheck
    }
}
